/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckDocumentProvisionMethod } from './PaxCheckDocumentProvisionMethod';
import {
    PaxCheckDocumentProvisionMethodFromJSON,
    PaxCheckDocumentProvisionMethodFromJSONTyped,
    PaxCheckDocumentProvisionMethodToJSON,
    PaxCheckDocumentProvisionMethodToJSONTyped,
} from './PaxCheckDocumentProvisionMethod';

/**
 * Request to provide scanned or uploaded images/files to resolve checklist item(s)
 * @export
 * @interface PaxCheckApplyRecognisedDocumentRequest
 */
export interface PaxCheckApplyRecognisedDocumentRequest {
    /**
     * List of documents got from /recognise-document
     * @type {Array<object>}
     * @memberof PaxCheckApplyRecognisedDocumentRequest
     */
    documents: Array<object>;
    /**
     * Document type recognised by /recognise-document
     * @type {string}
     * @memberof PaxCheckApplyRecognisedDocumentRequest
     */
    documentType: string;
    /**
     * Signature got from /recognise-document
     * @type {string}
     * @memberof PaxCheckApplyRecognisedDocumentRequest
     */
    signature: string;
    /**
     * 
     * @type {PaxCheckDocumentProvisionMethod}
     * @memberof PaxCheckApplyRecognisedDocumentRequest
     */
    method: PaxCheckDocumentProvisionMethod;
    /**
     * Whether document applied is travel document - should match DocumentRequirement.is_travel_document from Checklist item
     * @type {boolean}
     * @memberof PaxCheckApplyRecognisedDocumentRequest
     */
    isTravelDocument: boolean;
    /**
     * List of additional pax session ids to apply this document to (apart from main pax session id)
     * @type {Array<string>}
     * @memberof PaxCheckApplyRecognisedDocumentRequest
     */
    additionalPaxIds: Array<string>;
}



/**
 * Check if a given object implements the PaxCheckApplyRecognisedDocumentRequest interface.
 */
export function instanceOfPaxCheckApplyRecognisedDocumentRequest(value: object): value is PaxCheckApplyRecognisedDocumentRequest {
    if (!('documents' in value) || value['documents'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('signature' in value) || value['signature'] === undefined) return false;
    if (!('method' in value) || value['method'] === undefined) return false;
    if (!('isTravelDocument' in value) || value['isTravelDocument'] === undefined) return false;
    if (!('additionalPaxIds' in value) || value['additionalPaxIds'] === undefined) return false;
    return true;
}

export function PaxCheckApplyRecognisedDocumentRequestFromJSON(json: any): PaxCheckApplyRecognisedDocumentRequest {
    return PaxCheckApplyRecognisedDocumentRequestFromJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyRecognisedDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': json['documents'],
        'documentType': json['document_type'],
        'signature': json['signature'],
        'method': PaxCheckDocumentProvisionMethodFromJSON(json['method']),
        'isTravelDocument': json['is_travel_document'],
        'additionalPaxIds': json['additional_pax_ids'],
    };
}

export function PaxCheckApplyRecognisedDocumentRequestToJSON(json: any): PaxCheckApplyRecognisedDocumentRequest {
    return PaxCheckApplyRecognisedDocumentRequestToJSONTyped(json, false);
}

export function PaxCheckApplyRecognisedDocumentRequestToJSONTyped(value?: PaxCheckApplyRecognisedDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': value['documents'],
        'document_type': value['documentType'],
        'signature': value['signature'],
        'method': PaxCheckDocumentProvisionMethodToJSON(value['method']),
        'is_travel_document': value['isTravelDocument'],
        'additional_pax_ids': value['additionalPaxIds'],
    };
}

